import { t, validateNonEmpty } from "@superset-ui/core";

export function validateNumber(v: any) {
  const parsed = parseInt(v, 10);
  if (Number.isNaN(parsed)) {
    return t('need a number.');
  }
  return false;
}

export function validatePercentage(v: any) {
  const parsed = parseInt(v, 10);
  if (Number.isNaN(parsed)) {
    return t('need a number.');
  }
  if (parsed < 0 || parsed > 100) {
    return t('need a number in the range [0, 100].');
  }
  return false;
}

export default function validateForMaxThree(v: unknown) {
  if (Array.isArray(v) && v.length <= 3) {
    return t('need max 3 metrics.');
  }
  return false;
}

export const commonControlsConfig = {
  color: {
    type: 'TextControl',
    label: t('Color'),
    description: t(
      'RGB string or HEX code string.',
    ),
    renderTrigger: true,
  },
  tooltipFormat: {
    type: 'TextControl',
    label: t('Tooltip Format'),
    description: t(
      'String template for tooltip format. Ex: {a} <br/>{b}: {c} ({d}%).' +
      '{a} for series name, {b} for data item name, {c} for data value, {d} for percentage.'
    ),
    renderTrigger: true,
  },
  valueFormat: {
    type: 'TextControl',
    label: t('Value Format'),
    description: t(
      'String template for tooltip format. Ex: {value} km/h' +
      '{value} for metric value.'
    ),
    renderTrigger: true,
  },
  text: {
    type: 'TextControl',
    renderTrigger: true,
  },
  number: {
    type: 'TextControl',
    clearable: false,
    validators: [validateNonEmpty, validateNumber]
  },
  percentage: {
    type: 'TextControl',
    clearable: false,
    validators: [validateNonEmpty, validatePercentage]
  }
};
